import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { findPayments, generatePaymentsReport } from './gateway-payments-api';

import type { FindPaymentsRequestParams } from '../model/find-payments-params';
import type { Payment } from '../model/payment';

export const useFindPaymentsQuery = (
  requestOptions: FindPaymentsRequestParams,
  options: Omit<
    UseQueryOptions<{ payments: Payment[]; total: number }>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['find-payments', requestOptions],
    queryFn: async () => {
      const { items, pageInfo } = await findPayments(requestOptions);

      return {
        payments: items,
        total: pageInfo.total,
      };
    },
    placeholderData: keepPreviousData,
  });
};

export const useGenerateReportMutation = () => {
  return useMutation({
    mutationKey: ['generate-report'],
    mutationFn: async (requestParams: FindPaymentsRequestParams) =>
      generatePaymentsReport(requestParams),
  });
};
